<template>
  <div>
    <vue-tel-input
      :value="value"
      mode="international"
      type="number"
      :input-options="{ id: idEl, name: '', placeholder: 'Чтобы уточнить детали заказа' }"
      @input="$emit('input', $event)"
      @validate="onValidate"
    />
    <input
      type="hidden"
      :name="nameEl"
      :value="valueNumber"
    />
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'

export default {
  name: 'InputPhone',
  components: {
    VueTelInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    idEl: {
      type: String,
      default: '',
    },
    nameEl: {
      type: String,
      required: true,
    },
  },
  computed: {
    valueNumber() {
      try {
        return parseInt(this.$props.value.replace(/\D/g, ''), 10) || ''
      } catch (e) {
        console.error(e)
        return ''
      }
    },
  },
  methods: {
    onValidate(inputObj) {
      this.$emit('inputValid', inputObj.valid)
    },
  },
}
</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>
<style lang="scss">
 .vue-tel-input {
   border: solid 1px var(--pale-grey) !important;
   box-shadow: none !important;
   input.vti__input {
     border-radius: 0;
     border: none;
     border-left: solid 1px var(--pale-grey);
   }
 }
</style>
